import React from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

const RegisterInput = ({ onKeyDown, onChange, value, type, placeholder, error, errorText, setState }) => {
    return (
        <div className={styles.inputBlock}>
            <input
                type={type}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                className={classNames(styles.inputMail, {
                    [styles.inputError]: error,
                })}
                onChange={onChange}
                value={value}
            />
            {value?.length > 0 && (
                <img onClick={() => setState('')} className={styles.clearIcon} src={'/assets/img/steps3LoginLayout/iconClear.svg'} alt={''} />
            )}
            {error && errorText && <span>{errorText}</span>}
            {error && <img className={styles.errorIcon} src={'/assets/img/steps3LoginLayout/iconError.svg'} alt={'errorIcon'} />}
        </div>
    );
};

export default RegisterInput;
